import { render, staticRenderFns } from "./ChooseProductPanelProduct.vue?vue&type=template&id=81ad3294&"
import script from "./ChooseProductPanelProduct.vue?vue&type=script&lang=ts&"
export * from "./ChooseProductPanelProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports